import {useContext, useEffect, useState} from "react";
import {
  getMedicalRecordForm,
  getThongTinBenhAn
} from "../../../components/modal-benh-an/content/thong-tin-benh-an/ho-so-benh-an/service";
import {toast} from "react-toastify";
import {useHoSoBenhAnContext} from "../../../components/modal-benh-an/content/thong-tin-benh-an/ho-so-benh-an/context";
import {isDisabledTab} from "../../../helpers/modalBenhAn";
import {AppContext} from "../../../../appContext/AppContext";
import {RESPONSE_MESSAGE} from "../../../../utils/Constant";

type Props = {
  medicalRecordId: string;
  formName: string;
  reset?: boolean;
};

export const useDetailHoSoBenhAn = ({medicalRecordId, formName, reset}: Props) => {
  const [data, setData] = useState<any>();
  const {setIsLoading} = useContext(AppContext);

  useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  const getDetail = async () => {
    try {
      setIsLoading(true);
      const {data: response} = await getThongTinBenhAn(medicalRecordId, formName);
      setData(response);
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  return {data};
};

export const useMedicalRecordFormIO = ({medicalRecordCode, formCode,}: {
  medicalRecordCode: string;
  formCode: string;
}) => {
  const {setHideAction} = useHoSoBenhAnContext();
  const [formJSON, setFormJSON] = useState<any>();

  useEffect(() => {
    getFormIO();
  }, []);

  const getFormIO = async () => {
    try {
      const data = await getMedicalRecordForm(medicalRecordCode, formCode);
      const json = JSON.parse(data?.data);
      setFormJSON(json);
      setHideAction(isDisabledTab(json?.tags));
    } catch (error) {
      console.error(error);
    }
  };

  return {formJSON};
};
